<template>
  <div class="soft-container">
    <div class="soft-title">
      {{type==='deploy'?languages.softInstall.deploy:languages.softInstall.patch}}
    </div>
    <div class="soft-list"
         :style="{ height: listHeight }">
      <div class="soft-empty"
           v-if="showEmpty">
        <img src="~/assets/pics/noresult.png"
             alt="" />
        <p>{{ languages.softInstall.empty }}</p>
      </div>
      <div class="single-container"
           v-for="item in softList"
           :key="item.id">
        <div class="soft-preview">
          <div class="soft-info">
            <img class="img-preview"
                 :src="item.icon"
                 alt="" />
            <div>
              <div class="soft-name">
                {{ languages.lan==='cn'?item.name:item.uninstallParams}}
                <span class="soft-desc">
                  {{ languages.softInstall.softsize }}: {{ item.size }}MB
                </span>
              </div>
              <div class="soft-desc">
                {{ languages.softInstall.updatetime }}: {{ formatDate(item.updateTime) }} ( Ver:
                {{ item.version }} )
              </div>
              <div class="soft-desc">
                {{ languages.softInstall.softdesc }}:
                {{ languages.lan==='cn'?item.description:item.search }}
              </div>
            </div>
          </div>
          <div class="button-container">
            <el-button type="primary"
                       size="medium"
                       @click="handleInstall(item)"
                       :disabled="errorStatus || isRunning"
                       :loading="item.id === loaddingId"
                       :class="item.id !== loaddingId && isRunning ? 'is-disable' : ''">{{
            item.id === loaddingId && isRunning ? installStep(step) : languages.install
          }}</el-button>
          </div>
        </div>
        <div class="percent-bar">
          <div class="down-icon"
               v-if="item.id === loaddingId && showProgressBar">
            <i class="el-icon-download"></i>
          </div>
          <el-tooltip v-if="item.id === loaddingId && showProgressBar"
                      :content="languages.softInstall.downProgress + ': '
          + parseInt(downPercent) + '%'"
                      :visible-arrow="false"
                      placement="top"
                      popper-class="tooltip-style">
            <el-progress :percentage="parseInt(downPercent)"></el-progress>
          </el-tooltip>
          <el-tooltip v-if="item.id === loaddingId && showProgressBar"
                      :content="languages.softInstall.cancel"
                      :visible-arrow="false"
                      placement="bottom"
                      popper-class="tooltip-style">
            <div class="cancel-button">
              <i @click="stopDownload"
                 class="el-icon-circle-close"></i>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>
    <info-dialog :languages="languages"
                 :type="infoType"
                 :confirm="infoConfirm"
                 :show="dialogInfoVisible"
                 :tips="infoTips"
                 :submitting="submitting"></info-dialog>
    <confirm-dialog :languages="languages"
                    :type="confirmType"
                    :operate="operateMethod"
                    :show="dialogConfirmVisible"
                    :softname="installing"></confirm-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import socket from 'common/socket';
import tools from 'common/tools';
import InfoDialog from 'components/dialogs/InfoDialog.vue';
import ConfirmDialog from 'components/dialogs/ConfirmDialog.vue';

export default {
  components: {
    InfoDialog,
    ConfirmDialog,
  },
  data () {
    return {
      saveMode: false,
      dialogConfirmVisible: false,
      confirmType: '',
      operateMethod: 'install',
      installing: '',
      dialogInfoVisible: false,
      infoTips: {},
      infoType: 'info',
      infoConfirm: false,
      submitting: false,
      loaddingId: '',
      count: 0,
      showEmpty: false,
      listHeight: 0,
      softList: [],
      language: '',
      type: '',
      step: 'check',
      tempSocketDatas: '',
      downPercent: 0,
      showProgressBar: false,
      percentInterval: '',
      installInterval: '',
      connectSocketTimer: '',
      checkPreviousInstallTimer: '',
    };
  },
  computed: {
    ...mapState([
      'languages',
      'userInfo',
      'gridName',
      'deviceName',
      'errorStatus',
      'isRunning',
      'deployCount',
      'fixCount',
      'deployTask',
      'softTypeList',
      'fixTask',
      'socketStatus',
    ]),
    formatDate () {
      return (data) => {
        const date = /\d{4}-\d{1,2}-\d{1,2}/g.exec(data);
        return date[0];
      };
    },
    installStep () {
      return (step) => {
        switch (step) {
          case 'check':
            return this.languages.softInstall.checking;
          case 'down':
            return this.languages.softInstall.downloading;
          case 'uninstall':
            return this.languages.softInstall.uninstalling;
          case 'cancel':
            return this.languages.softInstall.canceling;
          default:
            return this.languages.softInstall.installing;
        }
      };
    },
  },
  methods: {
    ...mapMutations([
      'setPageNow',
      'setHomeHidden',
      'setShowFooter',
      'setSoftCount',
      'setIsRunning',
      'setFooterTips',
      'setDownloadSource',
    ]),
    ...mapActions([
      'softwareInstall',
      'saveLog',
      'saveDeployLog',
      'getPcDeployedTask',
    ]),
    /* software install */
    handleInstall (item) {
      console.log('item', item);
      this.loaddingId = item.id;
      this.setIsRunning(true);
      this.installPrecheck(this.deviceName, item);
    },
    handleClean () {
      socket.sendSocket(0, 'idesk_query(clean)', (res) => {
        console.log('handleClean', res);
        if (res.clean === 'ok') {
          this.step = 'check';
          this.loaddingId = '';
          this.setIsRunning(false);
        }
      });
    },
    showDialog (title, info, type = 'info', confirm = false) {
      this.infoType = type;
      this.infoConfirm = confirm;
      this.infoTips = { title, info };
      this.dialogInfoVisible = true;
      /* reset the installing status */
      this.loaddingId = '';
      this.setIsRunning(false);
    },
    /* software installing */
    async installPrecheck (pcCode, item) {
      this.tempSocketDatas = '';
      /* 3. get the software crypted datas from api */
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: item.id,
        pcName: pcCode,
      });
      console.log('installPrecheck', res);
      if (res.status === 'failed') {
        /* get crypted datas failed */
        this.showDialog(this.languages.softInstall.upgradeFail, this.languages.softInstall.contact, 'warn');
        this.saveLog({
          title: 'api_error',
          lan: this.languages.lan,
          softwareName: item.name,
          softwareId: item.id,
          target: `${this.type} > softTaskCreate`,
          description: res.data,
        });
        return;
      }
      /* 4. to get the datas for local service installation */
      const installDatas = {
        username: this.userInfo.username,
        softid: item.id,
        regVer: item.version,
        lan: 'SoftwareDeploy',
        path: res.data.encryptPath,
        key: res.data.key,
        type: this.type,
      };
      // console.log('installDatas', installDatas);
      const socketDatas = tools.toUnicode(JSON.stringify(installDatas));
      // console.log('socketDatas', socketDatas);
      /* 5. send download command to local service with install datas */
      this.step = 'check';
      this.tempSocketDatas = socketDatas;
      this.tempItem = item;
      socket.sendSocket(0, `idesk_check(${socketDatas})`, (result) => {
        console.log('idesk_check', result);
        const status = result.result;
        if (status === 'failed') {
          switch (result.error_msg) {
            case 'disk full':
              this.showDialog(
                this.languages.softInstall.installNote,
                this.languages.softInstall.diskFull.replace(/@/g, result.disk),
                'warn',
              );
              break;
            case 'process exist':
              this.showDialog(this.languages.softInstall.installNote,
                this.languages.softInstall.processExist, 'warn');
              break;
            default:
              this.showDialog(this.languages.softInstall.upgradeFail,
                this.languages.softInstall.contact, 'warn');
              break;
          }
          this.saveLog({
            title: 'check_error',
            lan: this.languages.lan,
            softwareName: item.name,
            softwareId: item.id,
            target: `${this.type} > installPrecheck`,
            description: result.error_msg,
          });
          this.tempSocketDatas = '';
          this.tempItem = '';
          return;
        }
        this.installSoftware();
      });
    },
    installSoftware () {
      this.saveMode = true;
      console.log('installSoftware', this.tempItem);
      this.loaddingId = this.tempItem.id;
      this.setIsRunning(true);
      this.dialogInfoVisible = false;
      this.step = 'down';
      this.tempItem.lan = this.languages.lan;
      window.localStorage.setItem('isInstall', JSON.stringify(this.tempItem));
      // console.log('tempSocketDatas', this.tempSocketDatas);
      socket.sendSocket(0, `idesk_download2(${this.tempSocketDatas})`, (result) => {
        const status = result.result;
        console.log('idesk_download2 >>>>>', result);
        if (status === 'failed') {
          this.showDialog(this.languages.softInstall.installFail, this.languages.softInstall.contact, 'warn');
          if (this.saveMode) {
            this.saveLog({
              title: 'download_error',
              lan: this.languages.lan,
              softwareName: this.tempItem.name,
              softwareId: this.tempItem.id,
              target: `${this.type} > installSoftware`,
              description: result.error_msg,
            });
            this.saveMode = false;
          }
          this.step = 'check';
          this.handleClean();
          return;
        }
        const { source, downway } = result;
        let time = '';
        if (status === 'download start') {
          this.showProgressBar = true;
          let downIndex = 0;
          this.percentInterval = setInterval(() => {
            downIndex += 1;
            if (downIndex >= 12000) {
              clearInterval(this.percentInterval);
              this.showDialog(this.languages.softInstall.downloadNote,
                `${this.languages.softInstall.downTimeout}, ${this.languages.softInstall.retry}`, 'warn');
              if (this.saveMode) {
                this.saveLog({
                  title: 'download_error',
                  lan: this.languages.lan,
                  softwareName: this.tempItem.name,
                  softwareId: this.tempItem.id,
                  target: `${this.type} > installSoftware`,
                  description: 'download timeout',
                });
                this.saveMode = false;
              }

              this.downPercent = 0;
              this.setFooterTips('');
              this.showProgressBar = false;
              this.handleClean();
              return;
            }
            socket.sendSocket(0, 'idesk_query(percent)', (rs) => {
              if (rs.percent === 'error') {
                clearInterval(this.percentInterval);
                this.showDialog(this.languages.softInstall.downloadNote,
                  `${this.languages.softInstall.downFailed}, ${this.languages.softInstall.retry}`, 'warn');
                this.saveLog({
                  title: 'download_error',
                  lan: this.languages.lan,
                  softwareName: this.tempItem.name,
                  softwareId: this.tempItem.id,
                  target: `${this.type} > installSoftware`,
                  description: 'aws download error',
                });
                this.downPercent = 0;
                this.setFooterTips('');
                this.showProgressBar = false;
                this.handleClean();
                return;
              }
              const downSize = Math.round((rs.size / 1024 / 1024) * 10) / 10;
              const totalSize = Math.round((rs.total / 1024 / 1024) * 10) / 10;

              if (downSize && totalSize) {
                this.setFooterTips(`${downSize}MB / ${totalSize}MB`);
                this.setDownloadSource(source);
              }
              if (rs.percent) this.downPercent = rs.percent;
              if (rs.percent === '100') {
                clearInterval(this.percentInterval);
                time = rs.time;
                this.downPercent = 0;
                this.setFooterTips('');
                this.showProgressBar = false;
                this.saveLog({
                  title: 'download_success',
                  lan: this.languages.lan,
                  softwareName: this.tempItem.name,
                  softwareId: this.tempItem.id,
                  target: `${this.type} > installSoftware`,
                  description: 'normal',
                  reserve1: time,
                  reserve3: source,
                  reserve4: downway,
                });
                /* 6. send install command to local service with install datas */
                if (this.tempItem.showTips) {
                  this.$message({
                    showClose: true,
                    message: this.tempItem.showTips,
                    type: 'success',
                    duration: 0,
                  });
                }
                const softData = this.tempItem;
                setTimeout(() => {
                  this.step = 'install';
                  this.saveMode = true;
                  let installIndex = 0;
                  this.installInterval = setInterval(() => {
                    installIndex += 1;
                    if (installIndex > 1800) {
                      clearInterval(this.installInterval);
                      this.showDialog(this.languages.softInstall.installNote,
                        `${this.languages.softInstall.installTimeout}, ${this.languages.softInstall.retry}`, 'warn');
                      if (this.step === 'install' && this.saveMode) {
                        this.saveLog({
                          title: 'install_error',
                          lan: this.languages.lan,
                          softwareName: softData.name,
                          softwareId: softData.id,
                          target: `${this.type} >  installSoftware`,
                          description: 'install timeout',
                        });
                        this.saveMode = false;
                      }
                      this.step = 'check';
                    }
                  }, 2000);
                  socket.sendSocket(0, `idesk_install(${this.tempSocketDatas})`, (rst) => {
                    console.log('idesk_install', rst);
                    const sts = rst.result;
                    if (sts === 'failed') {
                      this.showDialog(this.languages.softInstall.installFail, this.languages.softInstall.contact, 'warn');
                      this.saveLog({
                        title: 'install_error',
                        lan: this.languages.lan,
                        softwareName: this.tempItem.name,
                        softwareId: this.tempItem.id,
                        target: `${this.type} > installSoftware`,
                        description: rst.error_msg,
                      });
                    } else {
                      this.showDialog(this.languages.softInstall.installed,
                        this.languages.softInstall.installInfo);
                      this.saveLog({
                        title: 'install_success',
                        lan: this.languages.lan,
                        softwareName: this.tempItem.name,
                        softwareId: this.tempItem.id,
                        target: `${this.type} > installSoftware`,
                        description: 'normal',
                        reserve1: time,
                        reserve2: rst.time,
                        reserve3: source,
                        reserve4: downway,
                      });
                      this.addDeployedPc(this.tempItem.regName);
                    }
                    setTimeout(() => {
                      clearInterval(this.installInterval);
                      this.step = 'check';
                      window.localStorage.removeItem('isInstall');
                      this.handleClean();
                      this.tempSocketDatas = '';
                      this.tempItem = '';
                      this.setFooterTips('');
                    }, 500);
                  });
                }, 1000);
              }
            });
          }, 300);
        }
      });
    },
    async addDeployedPc (taskName) {
      console.log('this.tempItem', this.tempItem);
      const date = tools.getFormatDate(new Date());
      const pcInfo = { pcName: this.deviceName, updateTime: date };
      const pcList = [];
      pcList.push(pcInfo);
      const logResult = await this.saveDeployLog({ deploymentProjectName: taskName, pcList });
      console.log('saveDeployLog', logResult, { deploymentProjectName: taskName, pcList });
      // const logResult = 'OK';
      if (logResult === 'OK') {
        this.saveLog({
          title: 'deploy_success',
          lan: this.languages.lan,
          softwareName: taskName,
          softwareId: this.tempItem.id,
          target: `${this.type} > addDeployedPc`,
          description: 'update log success',
        });
        const index = this.softList.findIndex((itm) => (itm.regName === this.tempItem.regName));
        console.log('softList', this.softList, this.tempItem, index);
        if (index !== -1) this.softList.splice(index, 1);
        this.setSoftCount(this.softList.length);
        if (this.softList.length === 0) this.showEmpty = true;
      } else {
        this.saveLog({
          title: 'deploy_failed',
          lan: this.languages.lan,
          softwareName: taskName,
          softwareId: this.tempItem.id,
          target: `${this.type} > addDeployedPc`,
          description: 'update log failed',
        });
      }
    },
    checkPreviousInstall () {
      /* to check if has previous software install operate */
      this.checkPreviousInstallTimer = setInterval(() => {
        socket.sendSocket(0, 'idesk_query(status)', (res) => {
          console.log('idesk_query(status)', res);
          const previousSoft = JSON.parse(window.localStorage.getItem('isInstall'));
          // console.log('previousSoft', previousSoft);
          if (!previousSoft) {
            window.localStorage.removeItem('isInstall');
            this.setIsRunning(false);
            clearInterval(this.checkPreviousInstallTimer);
            return false;
          }
          if (res.isDown === 'free' && res.isInstall === '0') {
            this.setIsRunning(false);
            window.localStorage.removeItem('isInstall');
            clearInterval(this.checkPreviousInstallTimer);
            this.dialogConfirmVisible = false;
            return false;
          }
          if (res.isInstall !== '0') {
            this.confirmType = 'install';
            this.installing = previousSoft ? previousSoft.name : this.languages.softInstall.unknown;
            this.dialogConfirmVisible = true;
            return true;
          }
          if (res.isDown === 'downloading') {
            this.confirmType = 'down';
            this.installing = previousSoft ? previousSoft.name : this.languages.softInstall.unknown;
            this.dialogConfirmVisible = true;
            return true;
          }
          if (res.isDown === 'exist') {
            clearInterval(this.checkPreviousInstallTimer);
            this.confirmType = 'install';
            if (previousSoft.id.toString() === res.id) {
              this.saveLog({
                title: 'download_success',
                lan: this.languages.lan,
                softwareName: previousSoft.name,
                softwareId: previousSoft.id,
                target: `${this.type} >checkPreviousInstall`,
                description: 'previous',
                reserve1: res.down,
                reserve3: res.path,
                reserve4: res.way,
              });
            }

            this.installPrevious(this.deviceName, previousSoft, res);
            // this.confirmType = 'exist';
            this.installing = previousSoft ? previousSoft.name : this.languages.softInstall.unknown;
            this.dialogConfirmVisible = true;
            return true;
          }
          return false;
        });
      }, 1000);
    },
    async installPrevious (pcCode, software, previous) {
      console.log('installPrevious', pcCode, software, previous);
      const res = await this.softwareInstall({
        account: this.userInfo.username,
        softwareId: software.id,
        pcName: pcCode,
      });
      console.log('installPrecheck', res);
      /* socket error, quit previous install */
      if (res.status === 'failed') {
        /* get crypted datas failed */
        this.showDialog(this.languages.softInstall.installFail, this.languages.softInstall.contact, 'warn');
        this.saveLog({
          title: 'api_error',
          lan: this.languages.lan,
          softwareName: software.name,
          softId: software.id,
          target: `${this.type} > softTaskCreate`,
          description: res.data,
        });
        this.dialogConfirmVisible = false;
        window.localStorage.removeItem('isInstall');
        return;
      }
      let typeList = this.softTypeList;
      if (software.lan !== this.languages.lan) {
        const newTypeList = await this.getTypeList(software.lan);
        if (newTypeList.status !== 'success') {
          this.handleClean();
          this.dialogConfirmVisible = false;
          this.setIsRunning(false);
          return;
        }
        typeList = newTypeList.data;
      }
      /* to get the datas for local service installation */
      const index = typeList.findIndex((itm) => software.typeId === itm.id);
      /* for language change after previous software downloading init */
      const installType = index === -1 ? this.type : typeList[index].name;
      const installDatas = {
        username: this.userInfo.username,
        softid: software.id,
        regVer: software.version,
        lan: this.languages.lan,
        path: res.data.encryptPath,
        key: res.data.key,
        type: installType,
      };
      /* previous installation failed */
      const socketDatas = tools.toUnicode(JSON.stringify(installDatas));
      await socket.sendSocket(0, `idesk_install(${socketDatas})`, (rst) => {
        console.log('idesk_install_previous', rst);
        if (rst.result !== 'failed') {
          this.showDialog(this.languages.softInstall.installed,
            this.languages.softInstall.installInfo);
          this.saveLog({
            title: 'install_success',
            lan: this.languages.lan,
            softwareName: software.name,
            softwareId: software.id,
            target: `${this.type} > idesk_install_previous`,
            description: 'previous',
            reserve1: previous.down,
            reserve2: rst.time,
            reserve3: previous.path,
            reserve4: previous.way,
          });
          if (installType === this.type) {
            this.tempItem = software;
            this.addDeployedPc(software.regName);
          }
        }
        // this.homeTemplate.getUpgradeSoftList();
        // setTimeout(() => {
        //   this.homeTemplate.checkUninstallResult();
        // }, 1000);
        this.setIsRunning(false);
        this.dialogConfirmVisible = false;
        window.localStorage.removeItem('isInstall');
      });
    },
    async stopPreInstall (type) {
      window.localStorage.removeItem('isInstall');
      switch (type) {
        case 'down':
          socket.sendSocket(0, 'idesk_query(stopdown)', (res) => {
            clearInterval(this.checkPreviousInstallTimer);
            console.log('idesk_query(stopdown)', res);
            this.connectSocketTimer = setInterval(async () => {
              this.confirmType = 'stop';
              await socket.initSocket(0);
              if (this.socketStatus[0].socket !== '' && this.socketStatus[0].readyState === 1) {
                clearInterval(this.connectSocketTimer);
                this.handleClean();
                this.dialogConfirmVisible = false;
              }
            }, 1000);
          });
          break;
        case 'install':
          await socket.initSocket(0);
          if (this.socketStatus[0].socket !== '' && this.socketStatus[0].readyState === 1) {
            socket.sendSocket(0, 'idesk_query(stopinstall)', (res) => {
              clearInterval(this.checkPreviousInstallTimer);
              console.log('idesk_query(stopinstall)', res);
              this.handleClean();
              this.dialogConfirmVisible = false;
            });
          }
          break;
        default:
          break;
      }
      this.setIsRunning(false);
    },
    stopDownload () {
      this.step = 'cancel';
      clearInterval(this.percentInterval);
      window.localStorage.removeItem('isInstall');
      this.downPercent = 0;
      this.setFooterTips('');
      this.showProgressBar = false;
      try {
        socket.sendSocket(0, 'idesk_query(stopdown)');
      } catch (error) {
        console.log('error', error);
      } finally {
        this.connectSocketTimer = setInterval(async () => {
          await socket.initSocket(0);
          if (this.socketStatus[0].socket !== '' && this.socketStatus[0].readyState === 1) {
            clearInterval(this.connectSocketTimer);
            this.handleClean();
          }
        }, 1000);
      }
    },
    hideInfoDialog () {
      window.localStorage.removeItem('isInstall');
      this.dialogInfoVisible = false;
    },
    hideConfirmDialog () {
      this.dialogConfirmVisible = false;
      clearInterval(this.checkPreviousInstallTimer);
    },
    /* to set the softlist container height */
    getSoftListHeight () {
      const desc = document.body.clientWidth > 922 ? 170 : 205;
      this.listHeight = `${document.body.clientHeight - desc}px`;
      window.onresize = () => (() => {
        // const desc2 = document.body.clientWidth > 922 ? 170 : 205;
        this.listHeight = `${document.body.clientHeight - desc}px`;
      })();
    },
    getTypeCount () {
      this.type = this.gridName === 'Program Push' ? 'deploy' : 'fix';
      this.softList = this.type === 'deploy' ? this.deployTask : this.fixTask;
      this.setSoftCount(this.softList.length);
      if (this.softList.length === 0) this.showEmpty = true;
    },
  },
  async created () {
    this.setPageNow('SoftwareDeploy');
    this.setHomeHidden(false);
    this.setShowFooter(true);
    this.getTypeCount();
    // this.checkPreviousInstall();
  },
  watch: {
    languages () {
      this.language = this.languages.lan;
    },
  },
  mounted () {
    this.getSoftListHeight();
  },
  beforeDestroy () {
    clearInterval(this.checkPreviousInstallTimer);
    clearInterval(this.connectSocketTimer);
    clearInterval(this.percentInterval);
    clearInterval(this.installInterval);
  },
};
</script>

<style lang="scss" scoped>
.soft-container {
  background-color: #fff;
  padding: 0 10px;
  // position: relative;
}
.soft-title {
  height: 42px;
  font-size: 16px;
  line-height: 42px;
  color: #666;
  margin-left: 5px;
}
.is-disable {
  background-color: #999 !important;
  border: none !important;
}
.el-icon-loading {
  margin-right: 1px;
}
.soft-list {
  height: calc(100vh - 142px);
  overflow-x: hidden;
  overflow-y: auto;
}
.soft-empty {
  display: flex;
  flex-direction: column;
  position: absolute;
  text-align: center;
  align-items: center;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  img {
    width: 200px;
    height: 200px;
  }
}
.soft-preview {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .soft-info {
    display: flex;
  }
  .img-preview {
    width: 48px;
    height: 48px;
    margin-right: 20px;
    margin-top: 5px;
  }
  .soft-name {
    font-weight: 700;
    line-height: 24px;
    color: #333;
    span {
      margin-left: 10px;
      // color: #409bff;
      font-weight: 400;
      font-size: 13px;
    }
  }
  .soft-desc {
    line-height: 16px;
    font-size: 13px;
    color: #999;
    max-width: 520px;
  }
}
.single-container {
  height: 85px;
  padding-top: 10px;
  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;
  position: relative;
  margin-bottom: -1px;
}
.percent-bar {
  position: absolute;
  padding: 0 80px 0 95px;
  left: 0;
  right: 0;
  bottom: 5px;
}
.down-icon {
  position: absolute;
  left: 75px;
  color: #333;
}
.cancel-button {
  position: absolute;
  cursor: pointer;
  right: 65px;
  bottom: -2px;
}
.size-container {
  position: absolute;
  left: 10px;
  bottom: -33px;
  z-index: 1;
  font-size: 10px;
}
.button-container {
  display: flex;
  position: absolute;
  right: 10px;
}
</style>
